import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './local';

// Detectar idioma inicial del navegador de forma síncrona
const getBrowserLang = (): string => {
  const browserLang = navigator.language.split('-')[0];
  return browserLang === 'en' ? 'en' : 'es';
};

// Inicialización síncrona para que los componentes ya tengan traducciones al renderizar
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getBrowserLang(),
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

// Detección de idioma por geolocalización en segundo plano (sin bloquear el render)
const detectLanguageByLocation = async (): Promise<void> => {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();

    if (data.country_code === 'US') {
      i18n.changeLanguage('en');
      return;
    }

    const spanishCountries = ['MX', 'ES', 'AR', 'CO', 'CL', 'PE', 'VE', 'EC', 'GT', 'CU', 'BO', 'DO', 'HN', 'PY', 'SV', 'NI', 'CR', 'PA', 'UY', 'PR'];
    if (spanishCountries.includes(data.country_code)) {
      i18n.changeLanguage('es');
    }
  } catch {
    // Mantener el idioma del navegador si falla
  }
};

detectLanguageByLocation();

export default i18n;
